export const OTC_EXPIRATION_HOURS = 4
